//#region IMPORT
import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
/** Services Import */
import Global from '../../../Services/Common/Global';
import Commons from '../../../Services/Common/Common';
/** Components Import */
import M_TBG_BASIC_01 from './M_TBG_BASIC_01';
import { Loading } from '../../../Components/MUIs';
import { CommonActions } from '../../../Reducer/CommonReducer';
import { BottomSheetActions } from '../../../Reducer/BottomSheetReducer';
import { useBackStack } from '../../../Hooks/back/useBackStack';
//#endregion

function M_TBG_BASIC_01F(props) {
  //#region 변수
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);
  const dispatch = useDispatch();
  const activeStep = useSelector((state) => state.common.activeStep);
  const bottomSheetState = useSelector((state) => state.bottomSheet);
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    type: 'info',
  });

  const [inputs, setInputs] = useState({
    video: '',
    isNext: false,
  });
  const videoRef = useRef();
  const [played, setPlayed] = useState(0);
  const [play, setPlay] = useState(false);
  const [eduStart, setEduStart] = useState(false);
  const [modalToggle1, setModalToggle1] = useState(true); // qr코드 모달
  const [qrcode, setQrcode] = useState();
  //#endregion

  // 스택형 뒤로가기로 변경: TBM 관리자 시작 단계 이탈 시 확인 시트 표시
  useBackStack({
    type: 'sheet',
    enabled: !bottomSheetState.bottom,
    onBack: () =>
      dispatch(BottomSheetActions.OpenBottomSheet({ type: 'backClickTbm' })),
  });

  useEffect(() => {
    Init();
    return () => {
      dispatch(BottomSheetActions.CloseBottomSheet());
    };
  }, [dispatch]);

  const Init = async () => {
    setLoading(true);
    try {
      await SearchLogic1();
    } catch (e) {
      console.log(e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };
  //#region 조회
  // 동영상 조회
  const SearchLogic1 = async () => {
    setLoading(true);
    setInputs({
      ...inputs,
      video: '',
      isNext: true,
    });

    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_TBM_R2',
            _userid: userInfo.userid,
            _authCd: Commons.EncryptAES(userInfo.authCd) || '',
          },
        ]
      ).then((result) => {
        let data = result.data;

        if (data[0].type === 'Error') {
          throw new Error(data[0].message);
        } else {
          if (!data[0].VIDEO_LOCATION) {
            setInputs({
              ...inputs,
              video: '',
              isNext: true,
            });
          } else {
            const videoPath = data[0].VIDEO_LOCATION || '';
            const videoFullUrl = getFullFileUrl(videoPath);
            setInputs((prev) => ({
              ...prev,
              video: videoFullUrl,
            }));
          }
          setQrcode(data[0].TBM_CD);
        }
      });
    } catch (e) {
      console.log(e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  const getFullFileUrl = (relativePath) => {
    if (!relativePath) return '';
    const fixedPath = fixUrl(relativePath);
    return `${Global.file.useUrl}files/${fixedPath}`;
  };

  // URL 인코딩 처리
  const fixUrl = (url) => {
    if (!url || typeof url !== 'string') return '';
    const parts = url.split('/');
    const fileName = parts.pop();
    const encodedFileName = encodeURIComponent(fileName);
    return [...parts, encodedFileName].join('/');
  };

  //#endregion
  //#region 저장
  //TBM 회의 시작시간 저장
  const SaveLogic1 = async () => {
    setLoading(true);
    let saveData = [];
    try {
      saveData.push({
        procedureName: 'SP_TBM_U1',
        _USER_ID: userInfo.userid, // 담당자ID
        _CUST_CD: Commons.EncryptAES(userInfo.custCd) || '', // 사업장코드
        _VIDEO_PATH: Commons.EncryptAES('') || '', // 동영상 경로
        _FILE_PATH: Commons.EncryptAES('') || '', // 교육 파일 경로
        _PLAN_PATH: Commons.EncryptAES('') || '', // 작업계획서 경로
      });

      if (saveData.length > 0) {
        await Commons.Axios(
          'post1',
          Global.base.useUrl + Global.urls.Execute.execute,
          saveData
        ).then(async (result) => {
          let data = result?.data[0];
          if (data.type === 'Error') {
            throw new Error(data.message);
          } else {
            props.startTimeRef.current = new Date(data.TBM_START_DATE);
          }
        });
      }
    } catch (e) {
      console.log(e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };
  // tbmstatus 교육현황 저장
  const SaveLogic2 = async (_eStep, _mStep) => {
    setLoading(true);
    let saveData = [];

    try {
      saveData.push({
        procedureName: 'SP_TBM_STATUS_U1',
        _TBM_CD: Commons.EncryptAES(props.tbmCdRef.current) || '', // TBM코드
        _E_STEP: Commons.EncryptAES(_eStep.toString()) || '', // 근로자 교육 페이지
        _M_STEP: Commons.EncryptAES(_mStep.toString()) || '', // 관리자 교육 페이지
        _USER_ID: userInfo.userid, // 참석자ID
      });

      if (saveData.length > 0) {
        await Commons.Axios(
          'post1',
          Global.base.useUrl + Global.urls.Execute.execute,
          saveData
        ).then(async (result) => {
          let data = result?.data[0];

          if (data.type === 'Error') {
            throw new Error(data.message);
          } else {
            // setSnackbar({
            //   open: true,
            //   type: "success",
            //   message: "저장되었습니다.",
            // });
            // setModalToggle1(true);
          }
        });
      }
    } catch (e) {
      console.log(e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: 'error',
      });
    }
  };
  //#endregion
  //#region 삭제
  // 강제종료시 해당 tbmCd 관련 데이터 삭제
  const DeleteLogic1 = async () => {
    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_TBM_D1',
            _TBM_CD: Commons.EncryptAES(props.tbmCdRef.current),
          },
        ]
      );
    } catch (error) {
      console.error(error);
    }
  };
  //#endregion
  //#region 나머지 함수
  const HandleVideoError = (e) => {
    console.log('Video Error: ', e);
    if (e.type === 'error') {
      setInputs({
        ...inputs,
        video: '',
        isNext: true,
      });
    }
  };

  //비디오를 모두 시청 했는지 체크
  const HandleVideoEnd = () => {
    setInputs({
      ...inputs,
      isNext: true,
    });
  };

  const HandleProgress = (state) => {
    setPlayed(state.played);
  };

  const HandleSeek = (seekTime) => {
    if (!videoRef.current) return;

    try {
      const currentTime = videoRef.current.getCurrentTime();
      const duration = videoRef.current.getDuration();

      if (!duration || duration === 0) return;

      const playedFraction = currentTime / duration;
      if (playedFraction > played) {
        setPlayed(playedFraction);
      }
    } catch (error) {
      console.log('Seek Error: ', error);
    }
  };
  //#endregion

  return (
    <div className="wrap">
      <M_TBG_BASIC_01
        userInfo={userInfo}
        lanList={lanInfo}
        inputs={inputs}
        setInputs={setInputs}
        videoRef={videoRef}
        play={play}
        setPlay={setPlay}
        eduStart={eduStart}
        setEduStart={setEduStart}
        modalToggle1={modalToggle1}
        setModalToggle1={setModalToggle1}
        qrcode={qrcode}
        setQrcode={setQrcode}
        activeStep={activeStep}
        setActiveStep={(step) => dispatch(CommonActions.setActiveStep(step))}
        userCount={props.userCount}
        setUserCount={props.setUserCount}
        // 함수
        SaveLogic1={SaveLogic1}
        SaveLogic2={SaveLogic2}
        HandleVideoError={HandleVideoError}
        HandleVideoEnd={HandleVideoEnd}
        HandleProgress={HandleProgress}
        HandleSeek={HandleSeek}
        ActiveButton={props.ActiveButton}
        DeleteLogic1={DeleteLogic1}
      />
      <Loading open={loading} />
    </div>
  );
}

export default M_TBG_BASIC_01F;
